import React from 'react';
import { Login } from '../components/Login';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';


export const LoginView = ({ translate, currentLanguage }) => (
  <div>
    <Login />
  </div>
);
const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code

  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

const LoginViewConnected = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginView)
export default LoginViewConnected;



// WEBPACK FOOTER //
// ./src/views/LoginView.js